import { AlertTriangle, CheckCircle2, CircleHelp, TrendingDown, TrendingUp } from "lucide-react";
import type { SimpleContributionStatus, SimpleCostStatus, SimpleMarketPosition } from "../../lib/types";
import { Badge } from "../../components/ui";

export function CostStatusChip({ status }: { status: SimpleCostStatus }) {
  if (status === "Profitable") return <Badge tone="success" className="gap-1"><CheckCircle2 className="size-3.5" />Profitable</Badge>;
  if (status === "HighCost") return <Badge tone="warning" className="gap-1"><AlertTriangle className="size-3.5" />High cost</Badge>;
  if (status === "NotProfitable") return <Badge tone="danger" className="gap-1"><AlertTriangle className="size-3.5" />Not profitable</Badge>;
  return <Badge tone="neutral" className="gap-1"><CircleHelp className="size-3.5" />Incomplete</Badge>;
}

export function ContributionStatusChip({ status }: { status: SimpleContributionStatus }) {
  if (status === "Profitable") return <Badge tone="success" className="gap-1"><CheckCircle2 className="size-3.5" />Profitable</Badge>;
  if (status === "LowMargin") return <Badge tone="warning" className="gap-1"><AlertTriangle className="size-3.5" />Low margin</Badge>;
  if (status === "NotProfitable") return <Badge tone="danger" className="gap-1"><TrendingDown className="size-3.5" />Not profitable</Badge>;
  return <Badge tone="neutral" className="gap-1"><CircleHelp className="size-3.5" />Margin unavailable</Badge>;
}

export function contributionTextClass(status: SimpleContributionStatus) {
  if (status === "Profitable") return "text-emerald-700";
  if (status === "LowMargin") return "text-amber-700";
  if (status === "NotProfitable") return "text-red-700";
  return "text-slate-500";
}

export function MarketPositionChip({ position }: { position: SimpleMarketPosition }) {
  if (position === "BelowMarket") return <Badge tone="info" className="gap-1"><TrendingDown className="size-3.5" />Below market</Badge>;
  if (position === "WithinMarket") return <Badge tone="success" className="gap-1"><CheckCircle2 className="size-3.5" />Within market</Badge>;
  if (position === "AboveMarket") return <Badge tone="warning" className="gap-1"><TrendingUp className="size-3.5" />Above market</Badge>;
  return <Badge tone="neutral" className="gap-1"><CircleHelp className="size-3.5" />No market data</Badge>;
}
